import axios from '../axios'

/* 
 * 移动应用介绍
 */
//查询
export const getListApi = (params) => {
  return axios({
      url: '/app/desc',
      method: 'get',
      params
  })
}
// 新增
export const addApi = data => {
    return axios({
        url: '/home/banner',
        method: 'post',
        data
    })
}
//更新
export const updateApi = data => {
  return axios({
      url: '/home/banner',
      method: 'put',
      data
  })
}
//查详情
export const detailApi= (id) => {
  return axios({
      url: `/home/banner/${id}`,
      method: 'get',
      // params
  })
}
//删除
export const deleteApi= (id) => {
  return axios({
      url: `/home/banner/${id}`,
      method: 'delete',
      // params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/introduce.js